import ApiService from './ApiService';

class PlaceOrderService {
  async placeBuyOrder(payload = {}) {
    try {
      const response = await ApiService.call('/secured/place_buy_order', 'POST', payload);
      let data = response;

      console.log(response);

      return {
        orderId: data.orderId,
        success: true,
        message: 'Order placed successfully!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async placeSellOrder(payload = {}) {
    try {
      const response = await ApiService.call('/secured/place_sell_order', 'POST', payload);
      let data = response;

      return {
        orderId: data.orderId,
        success: true,
        message: 'Order placed successfully!',
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new PlaceOrderService();
